<template>
  <div
    class="vhp-card"
    @click="onClickCard(content)"
    :class="showSimple ? 'simple' : ''"
  >
    <div class="vhp-card-wrap">
      <div class="vhp-card-title" v-if="showTitle">
        <!-- <img  alt="catgory" :src="require('@/assets/image/category/' + content.category.toLowerCase() + '.svg')"/> -->

        <span class="category">{{ $t(content.category) }}</span>
      </div>

      <div class="vhp-card-image">
        <img
          alt="card-image"
          :src="content.image || ''"
          cover
          @error="replaceImage"
        />
      </div>

      <div class="vhp-card-content">
        <strong class="vhp-card-content-title">{{ content.title }}</strong>

        <div
          class="vhp-card-content-tags"
          v-if="content.hashTags && content.hashTags.length > 0 && !showSimple"
        >
          <span
            v-for="tag in content.hashTags.slice(0,3)"
            :key="'hashtag-' + tag"
            class="tag"
          >
            #{{ tag }}
          </span>
        </div>

        <div class="vhp-card-content-date" v-if="!showSimple">
          {{ cardDate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return null;
      },
    },
    baseUrl: {
      type: String,
      default: "/",
    },
    listUrl: {
      type: String,
      default: "/",
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    showSimple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardDate() {
      if (!this.content) return this.defaultDateString();
      const raw = this.content.editedDate || this.content.createdDate;
      if (!raw) return this.defaultDateString();
      if (typeof raw === 'string') return raw.slice(0, 10);
      if (raw.year != null && raw.month != null && raw.day != null)
        return `${raw.year}-${String(raw.month).padStart(2, '0')}-${String(raw.day).padStart(2, '0')}`;
      return this.defaultDateString();
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    defaultDateString() {
      const d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    onClickCard(content) {
      if (content.isExternalLink) {
        window.open(content.externalUrl);
      } else {
        this.$router.push(
          this.baseUrl + "?id=" + content.id + "&list=" + this.listUrl
        );
      }
    },

    replaceImage(e) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const container = document.getElementsByClassName("vhp-card-image")[0];

      canvas.width = container.clientWidth;
      canvas.height = 280;

      ctx.font =
        "32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif ";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillStyle = "#C4182890";
      ctx.fillRect(0, 0, container.clientWidth, 280);

      ctx.fillStyle = "#C4182830";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 0);
      ctx.lineTo(container.clientWidth, 0);
      ctx.lineTo(container.clientWidth, 200);
      ctx.fill();

      ctx.fillStyle = "#C4182860";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 280);
      ctx.lineTo(container.clientWidth, 280);
      ctx.lineTo(container.clientWidth, 140);
      ctx.fill();

      ctx.fillStyle = "#FFFFFF";
      ctx.fillText(this.content.title, container.clientWidth / 2, 140);
      let src = canvas.toDataURL("image/png", 1.0);
      e.target.src = src;
    },
  },
};
</script>

<style lang="scss" scoped src="./vhpCard.scss"></style>
